<template>
  <div class="mobileViewAll botPage">
    <mbHeader title="" :left="true" :lang="true">
      <div class="search-bar" style="margin-left: 5px">
        <input
          type="text"
          :placeholder="$t('search')"
          v-model="searchTerm"
        >
        <div class="hoverBtn" @click="searchProduct">
          <font-awesome-icon icon="search" :style="{ color: 'white', fontSize: '12px' }"/>
        </div>
      </div>
    </mbHeader>

    <div class="centerBanner">
      <img src="../../assets/img/afmCenterBanner.png" @click="selectCustomCategory(item)"/>
    </div>

    <div class="ViewAll-list" :class="{isFixed:isFixed}">
      <div class="ViewAll-bar">
        <div class="cat-swiper" ref="cat-swiper">
          <div :ref="`cat-s-item-${index}`" v-for="(item,index) in this.categories" :key="index" v-if="!item.IsButton" class="cat-slide">
            <p @click="setNewCategory(item)" :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "
               v-if='$i18n.locale=="en"'>{{ capitalizeOnlyFirstLetter(item.Name) }}</p>
            <p @click="setNewCategory(item)" :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "
               v-if='$i18n.locale=="ch"'>{{ item.Description }}</p>
          </div>
        </div>
<!--                <swiper :options="catScroll2" class="cat-swiper">-->
<!--                  <swiper-slide v-for="(item,index) in this.categories" :key="index" v-if="!item.IsButton" class="cat-slide">-->
<!--                    <p @click="setNewCategory(item)" :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "-->
<!--                       v-if='$i18n.locale=="en"'>{{ capitalizeOnlyFirstLetter(item.Name) }}</p>-->
<!--                    <p @click="setNewCategory(item)" :class="selectedCategoryProducts.Name === item.Name ? 'selected' : '' "-->
<!--                       v-if='$i18n.locale=="ch"'>{{ item.Description }}</p>-->
<!--                  </swiper-slide>-->
<!--                </swiper>-->
      </div>
      <ul>
        <!--        v-if="(showMore || index<  6)"-->
        <li v-for="(p, index) in this.selectedCategoryProducts.Products">
          <mobileProductCardLarge v-if='$i18n.locale=="en"'
                                  v-bind:img="p.Thumbnail"
                                  v-bind:link="p.link"
                                  v-bind:brand="p.Brand"
                                  v-bind:rating="p.Rating"
                                  v-bind:name="p.Name"
                                  v-bind:isPromotion="p.IsPromotion"
                                  v-bind:price="p.Price"
                                  v-bind:item="p"
                                  v-bind:quantity="p.Quantity"
                                  v-bind:key="index"
          ></mobileProductCardLarge>
          <mobileProductCardLarge v-if='$i18n.locale=="ch"'
                                  v-bind:img="p.Thumbnail"
                                  v-bind:link="p.link"
                                  v-bind:brand="p.Brand"
                                  v-bind:rating="p.Rating"
                                  v-bind:name="p.Description"
                                  v-bind:isPromotion="p.IsPromotion"
                                  v-bind:price="p.Price"
                                  v-bind:item="p"
                                  v-bind:quantity="p.Quantity"
                                  v-bind:key="index"
          ></mobileProductCardLarge>
        </li>
      </ul>
      <!--      <div v-else-if="isLoading" class="loadingWindow">-->
      <!--        <img src="../assets/img/loading.gif" alt="">-->
      <!--      </div>-->
      <recommended></recommended>
    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";

import mbHeader from "../../components/mobile/mbHeader";
import recommended from "../recommended";
import mobileProductCardLarge from './mobileProductCardLarge';
import Utils from "../../assets/js/util";

const scrollToDom = function (newVal) {
  if (!newVal || !Array.isArray(newVal) || newVal.length < 1) {
    return
  }
  const queryName = this.$route.query.name;
  if (!queryName) {
    return;
  }
  const name = decodeURIComponent(queryName)
  const item = newVal.find(item => item.Name === name);
  if (!item) {
    return;
  }
  this.setNewCategory(item)
  this.$nextTick(() => {
    const index = newVal.findIndex(item => item.Name === name);
    const comC = this.$refs[`cat-s-item-${index}`][0]
    comC && comC.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'center'
    })
  })
}

export default {
  name: "mobileViewAll",
  components: {mbHeader, recommended, mobileProductCardLarge},
  data() {
    return {
      searchTerm: '',
      selectedCategoryProducts: {
        Products: []
      },
      categories: [],
      catScroll2: {
        slidesPerView: 4,
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        },
        breakpoints: {
          300: {
            slidesPerView: 2,
          },
          390: {
            slidesPerView: 3,
          },
          500: {
            slidesPerView: 4
          },
          600: {
            slidesPerView: 5
          },
          800: {
            slidesPerView: 6
          }
        }
      },
      isFixed: false,
    }
  },
  activated() {
    this.isFixed = false
    this.scrollToDom(this.categories)
  },
  mounted() {
    // this.$store.dispatch('billboard/fetchBillboardImages');
    this.$store.dispatch('products/fetchCustomCategories');

    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    watchScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // let isFixed = scrollTop > this.offsetTop ? true : false;
      // console.log(scrollTop);

      this.isFixed = scrollTop >= 108;
    },
    setCategoryValues(newVal) {
      this.selectedCategoryProducts = newVal[0];
      // console.log(this.selectedCategoryProducts);
      let newCategory = {Name: 'All Categories', Description: '所有分類'};
      let oldCategories = newVal.slice();
      oldCategories.push(newCategory);
      this.categories = oldCategories;
    },
    capitalizeOnlyFirstLetter(string) {
      let lowercase = string.toLowerCase();
      return lowercase[0].toUpperCase() + lowercase.slice(1);
    },
    setNewCategory(category) {
      if (category.Name === 'All Categories') {
        this.$router.push('/collections')
      } else {
        this.selectedCategoryProducts = category;
        this.showMore = false;
      }
    },
    searchProduct() {
      Utils.$emit("clearList");
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewSearch(this.searchTerm, 'Name');
      }, 300);
    },
    selectCustomCategory(cat2) {
      this.$router.push(`/collections`);
      setTimeout(() => {
        this.$root.selectNewCustomCategory(cat2);
      }, 300);
    },
    scrollToDom: scrollToDom
  },
  computed: mapState({
    customCategories: state => state.products.customCategories,
  }),
  watch: {
    customCategories: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setCategoryValues(newVal);
      }
    },
    categories: scrollToDom
  },
}
</script>

<style scoped lang="less">
.mobileViewAll {
  padding: 76px 16px 0;

  .centerBanner {
    width: 100%;

    img {
      width: 100%;
      display: block;
    }
  }

  .ViewAll-list {
    padding: 16px 0 0;
    margin: 0;
    &.isFixed {
      padding-top: 60px;
      .ViewAll-bar{
        width: 100%;
        position: fixed;
        top: 50px;
        left: 0;
        padding: 16px;
        background-color: #FFFFFF;
        box-shadow: 0 1px 1px #efefef;
        margin-bottom: 0;
      }
    }

    .ViewAll-bar {
      margin: 0 0 16px;
      overflow: hidden;

      .cat-swiper {
        display: flex;
        justify-content: flex-start;
        text-align: center;
        overflow-x: scroll;
        &::-webkit-scrollbar {display:none}
        .cat-slide{
          //min-width: calc(33.3% - 10px);
          //padding: 0 10px;
          flex-shrink: 0;
        }
        p {
          font-size: 12px;
          padding: 5px 15px;
          font-family: 'Raleway';
        }

        .selected {
          color: white;
          background: black;
          border-radius: 25px;
          padding: 6px 15px;
        }
      }

      .cat-swiper {
        justify-content: flex-start;

        .cat-slide {
          justify-content: center;

          swiper-wrapper {
            justify-content: flex-start;
          }
        }
      }
    }

    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        width: calc(50% - 7px) !important;

        .product-card-large {
          margin: 0 0 14px 0;

          .product_box {
            padding: 10px;
            width: 100%;

            .Pro-Details {
              width: 100%;

              .price-bot {
                .review-container-card {
                  .star-img-container {
                    display: flex;
                    align-items: center;

                    .star-img {
                      width: 10px;
                      height: 10px;
                      display: block;
                    }

                    .star-text {
                      padding-top: 3px;
                      margin-left: 3px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileViewAll.vue